import COLORS from '@/constants/colors';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import { Stack, TableCell, TableRow } from '@mui/material';
import { ProductUi } from '../CartUiModel';

const cellStyle = {
  fontSize: '12px',
  color: COLORS.gray_800,
  borderBottom: 'none',
};

export const ProductLine = ({ product }: { product: ProductUi }) => {
  return (
    <TableRow
      key={product.id}
      sx={{
        borderTop: `1px solid ${COLORS.gray_7}`,
      }}
    >
      <TableCell sx={{ ...cellStyle, fontWeight: 600 }}>
        {product.sellerName}
      </TableCell>
      <TableCell
        sx={{ ...cellStyle, display: 'flex', direction: 'row', gap: '16px' }}
      >
        {product?.imageUrl ? (
          <img
            style={{ width: '44px', height: '44px', alignSelf: 'center' }}
            src={product.imageUrl}
            alt={product.productName || 'prod'}
          />
        ) : (
          <ImageNotSupportedOutlinedIcon
            style={{ width: '16px', height: '16px' }}
          />
        )}

        <Stack>
          <span style={{ fontWeight: 500 }}>{product.productName}</span>
          <span style={{ fontWeight: 500, color: COLORS.gray_500 }}>
            {product.presentation}
          </span>
          <span style={{ fontWeight: 500 }}>{product.pricingLabel}</span>
        </Stack>
      </TableCell>
      <TableCell sx={cellStyle}>
        <span>
          {product.quantity} {product.selectorUnitName}
        </span>
      </TableCell>
      <TableCell sx={cellStyle}>
        <span>
          ${product.customPricing} / {product.unitName}
        </span>
      </TableCell>
      <TableCell sx={{ ...cellStyle }}>
        <Stack direction={'row'} alignItems={'center'}>
          <span>${product.total}</span>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
